import * as React from 'react';
import ProductCard from '../ProductCard/ProductCard';
import FlyersUsServiceInstance from 'src/services/products/PromosUsService';
import listService from 'src/services/lists/ListsService';
import './PromosUs.scss';
import env from 'src/shared/env';
import i18n from 'src/translation/i18n';
import ProductCardLoading from 'src/components/common/ProductCardLoading';

interface IFlyersUs {
  isLoading: boolean;
  products: [];
  priceList: any[];
  bannerImageURL: string;
  flyerClassPoistion: string;
  batchSize: number;
  batchIndex: number;
  hasMore: boolean;
  isProductDetailsLoading: boolean;
  isFavoriteLoading:boolean;
  selectedFavoriteItem: string;
  batchEnd: number;
}

class FlyersUs extends React.Component<any, IFlyersUs> {
  private BannerURL: string = `${env.REACT_APP_BASE_WORDPRESS_URL}wp-content/themes/reliable-parts-wp-theme/inc/assets/imgs/flyer/flyer.jpg`;
  private today = new Date();
  constructor(props: any) {
    super(props);
    this.state = {
      isLoading: true,
      products: [],
      priceList: [],
      bannerImageURL: '',
      flyerClassPoistion: '',
      batchSize: 10,
      batchIndex: 0, 
      hasMore: true,
      isProductDetailsLoading: false,
      isFavoriteLoading: false,
      selectedFavoriteItem:'',
      batchEnd:0
    };
  }

  public getProducts = () => {
    setTimeout(() => {  
    FlyersUsServiceInstance.getProducts().then(res => {
      const selectedParameters: any[] = [];
      if (!Array.isArray(res) || res.length === 0) {
        this.setState({
          isProductDetailsLoading: false,
          hasMore: false
        });
      }  
      res.forEach((a: any) => {
        if (
          (Boolean(a.acf.isactive) || Number(a.acf.isactive) === 1) &&
          a.acf.product_position === 'center' &&
          this.props.location.pathname === '/promos-us/center'
        ) {
          selectedParameters.push(a);
        } else if (
          (Boolean(a.acf.isactive) || Number(a.acf.isactive) === 1) &&
          a.acf.product_position === 'right' &&
          this.props.location.pathname === '/promos-us/right'
        ) {
          selectedParameters.push(a);
        } else if (
          (Boolean(a.acf.isactive) || Number(a.acf.isactive) === 1) &&
          a.acf.product_position === 'left' &&
          this.props.location.pathname === '/promos-us/left'
        ) {
          selectedParameters.push(a);
        }
      });

      this.setState({
        products: res
      });
      this.getPriceList(selectedParameters,'MAIN');
    });
  }, 1000);
  };

  // Dynamic landingpage flyerbanner
  public getFlyBanners = () => {
    const currentDate =
      this.today.getDate() +
      '/' +
      (this.today.getMonth() + 1) +
      '/' +
      this.today.getFullYear();
    FlyersUsServiceInstance.getFlyerBanner().then(res => {
      res.forEach((a: any) => {
        if (
          a.acf.isactive &&
          a.acf.issalelive === 'Yes' &&
          a.acf.startdate <= currentDate &&
          a.acf.enddate >= a.acf.startdate &&
          a.acf.flyerposition === 'center' &&
          this.props.location.pathname === '/promos-us/center'
        ) {
          this.setState({
            bannerImageURL: a.acf.bannerimage,
            flyerClassPoistion: 'flyer-center'
          });
        } else if (
          a.acf.isactive &&
          a.acf.issalelive === 'Yes' &&
          a.acf.startdate <= currentDate &&
          a.acf.enddate >= a.acf.startdate &&
          a.acf.flyerposition === 'left' &&
          this.props.location.pathname === '/promos-us/left'
        ) {
          this.setState({
            bannerImageURL: a.acf.bannerimage,
            flyerClassPoistion: 'flyer-left'
          });
        } else if (
          a.acf.isactive &&
          a.acf.issalelive === 'Yes' &&
          a.acf.startdate <= currentDate &&
          a.acf.enddate >= a.acf.startdate &&
          a.acf.flyerposition === 'right' &&
          this.props.location.pathname === '/promos-us/right'
        ) {
          this.setState({
            bannerImageURL: a.acf.bannerimage,
            flyerClassPoistion: 'flyer-right'
          });
        }
        //  else {
        //   this.setState({
        //     bannerImageURL: this.BannerURL,
        //     flyerClassPoistion: 'flyer-normal'
        //   });
        // }
      });
      this.setState({ isLoading: false });
    });
  };

  private getPriceList = (product: any, frm:any) => {
    if (this.state.isProductDetailsLoading || this.state.hasMore===false){
      return;
    } 
    const { batchIndex, batchSize } = this.state;
    let start=0;
    let end=0;
    if(frm==="TOGGLEFAVORITE"){
      start=0;
      end=this.state.batchEnd;
      this.setState({ isProductDetailsLoading: false });

    }else{
      start = batchIndex * batchSize;
      end= start + batchSize;
      this.setState({ isProductDetailsLoading: true });
    }
    // const start = batchIndex * batchSize;
    // const end = start + batchSize;
    const batchParts = product.slice(start, end);
    this.setState({ batchEnd: end });
    if (batchParts.length === 0) {
      this.setState({ hasMore: false, isProductDetailsLoading: false });
      return;
    }
    const parameters: any = batchParts.map((parameter: any) => {
      return {
        manufacturerCode: parameter.acf.product_mfc,
        productNumber: parameter.acf.product_name
      };
    });

    if(frm==="TOGGLEFAVORITE"){
      FlyersUsServiceInstance.getPriceList(parameters, product, start, end).then((details) => {
        this.setState((prevState) => ({
          priceList:details,
          batchIndex: prevState.batchIndex,
          isProductDetailsLoading: false,
          isFavoriteLoading: false
        }));
      })
      .catch(() => this.setState({ isProductDetailsLoading: false }));
    }else{
      FlyersUsServiceInstance.getPriceList(parameters, product, start, end).then((details) => {
        this.setState((prevState) => ({
          priceList: [...prevState.priceList, ...details],
          batchIndex: prevState.batchIndex + 1,
          isProductDetailsLoading: false,
          isFavoriteLoading: false
        }));
      })
      .catch(() => this.setState({ isProductDetailsLoading: false }));
    }
  };

  public handleBuyNow = (endpoint: string) => {
     window.location.assign(`${env.REACT_APP_BASE_WORDPRESS_URL}${endpoint}`);
     window.scrollTo(0, 0);
  };

  private handleToggleFavorite = (
    name: string,
    mfc: string,
    favorite: boolean,
    favoriteId: number
  ) => {
    if (favorite) {
      this.setState({ isFavoriteLoading: true,selectedFavoriteItem: name });
      listService.deleteItem(favoriteId).then(res => {
        this.setState({ hasMore: true, isProductDetailsLoading: false });
        this.getPriceList(this.state.products, 'TOGGLEFAVORITE');
      }).catch(error => {
        console.error("Failed to delete item:", error);
        this.setState({ isFavoriteLoading: false }); 
      });
    } else {
      this.setState({ isFavoriteLoading: true,selectedFavoriteItem: name });
      listService
        .addItem('favorites', name, mfc)
        .then(res => {
        this.setState({ hasMore: true, isProductDetailsLoading: false });
        this.getPriceList(this.state.products, 'TOGGLEFAVORITE')
        }
        ).catch(error => {
          console.error("Failed to add item:", error);
          this.setState({ isFavoriteLoading: false });
        });
    }
  };

  private reloadList = () => {
    this.getProducts();
  };

  public componentDidMount() {
    this.getProducts();
    // FlyersUsServiceInstance.getFlyerBanner();
    this.getFlyBanners();
    window.addEventListener("scroll", this.handleScroll);
  }

  public componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  }

  public handleScroll = () => {
    if (
      window.innerHeight + document.documentElement.scrollTop >=
      document.documentElement.offsetHeight - 300
    ) {
      if(this.state.products.length===0){
        this.getProducts();  
      }else{
        this.getPriceList(this.state.products,'SCROLL');

      }
    }
  };

  private renderLoadingElements = () => {
    const items = [];
    let i = 0;
    while (i < 5) {
      items.push(
         <ProductCardLoading/>
      );
      i++;
    }
    return items;
  };

  public render() {
    const path = window.location.pathname;
    // console.log('this.state.bannerImageURL', this.state.bannerImageURL);
    return (
      <>
          <div>
          {this.state.isLoading ? (
          <div className="loader-container">
            <div className="loader" />
          </div>
        ) :(
            <div
              id="flyersbanner"
              className={this.state.flyerClassPoistion}
              style={{
                backgroundImage: `url(${
                    this.state.bannerImageURL
                })`
              }}
            />
          )}
            <div className="rp-flyers-section">
              {this.state.priceList.length > 0  &&
                this.state.priceList.map((product, index) => {
                  return (
                    <div key={index} className="card-container">
                      {/* {console.log('product', product.position)} */}
                      <ProductCard
                        section={true}
                        key={index}
                        part={product}
                        id={product.productNumber}
                        name={product.productNumber}
                        mfc={product.manufacturerCode}
                        description={product.description}
                        price={product.partnerPrice}
                        msrp={product.retailPrice}
                        image={product.product_image}
                        handleOnClicBuyNow={this.handleBuyNow}
                        handleToggleFavorite={this.handleToggleFavorite}
                        inStock={product.inStock}
                        isFavoriteLoading = {this.state.isFavoriteLoading}
                        selectedFavoriteItem = {this.state.selectedFavoriteItem}
                        favorite={product.favorite}
                        favoriteId={product.idFavoriteItem}
                        deal={!!product.discountInfo}
                        state={product.state}
                        stateDescription={product.stateDescription}
                        reloadPart={this.reloadList}
                        brand={product.brand}
                        viewDetails={product.view_details}
                      />
                    </div>
                  );
                })}
                
                {this.state.priceList.length ===0 && !this.state.hasMore && 
                  <div className='flyer-not-found'>{i18n.t('flyers.flyerPartsNotAvail')}</div>
                  }
              
                  { this.state.isProductDetailsLoading &&
                  <div className="rp-parts-flyer-grid">
                    {this.renderLoadingElements()}
                  </div>
                  }
            </div>
        
         </div>
      </>
    );
  }
}

export default FlyersUs;
